import * as VueRouter from "vue-router";
import Home from "@/components/Pages/Home/Home.vue";
import Suppliers from "@/components/Pages/Suppliers/Suppliers.vue";
import Login from "@/components/Pages/Login/Login.vue";
import ContentPages from "@/components/Pages/ContentPages/ContentPages.vue";
import ContentPageEdit from "@/components/Pages/ContentPages/ContentPageEdit.vue";
import BannerEdit from "@/components/Pages/Banner/BannerEdit.vue";
import BannersPage from "@/components/Pages/Banner/BannersPage.vue";
import MenuCategoryList from "@/components/Pages/MenuCategory/MenuCategoryList.vue";
import MenuCategoryEdit from "@/components/Pages/MenuCategory/MenuCategoryEdit.vue";
import SubcategoryTagPage from "@/components/Pages/SubcategoryTag/SubcategoryTagPage.vue";
import SubcategoryTagEdit from "@/components/Pages/SubcategoryTag/SubcategoryTagEdit.vue";
import Categories from "@/components/Pages/Categories/Categories.vue";
import CategoryEdit from "@/components/Pages/Categories/CategoryEdit.vue";

import Subcategories from "@/components/Pages/Subcategories/Subcategories.vue";
import SubcategoryEdit from "@/components/Pages/Subcategories/SubcategoryEdit.vue";


const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/suppliers",
    name: "suppliers",
    component: Suppliers,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/content-pages",
    name: "content-pages",
    component: ContentPages,
  },
  {
    path: "/content-pages/:id",
    name: "content-page-edit",
    component: ContentPageEdit,
  },
  {
    path: "/banners",
    name: "banners",
    component: BannersPage,
  },
  {
    path: "/banners/:id/edit",
    name: "banners-edit",
    component: BannerEdit,
  },
  {
    path: "/banners/new",
    name: "banners-create",
    component: BannerEdit,
  },

  {
    path: "/menu-categories",
    name: "menu-categories",
    component: MenuCategoryList,
  },
  {
    path: "/menu-categories/:id/edit",
    name: "menu-categories-edit",
    component: MenuCategoryEdit,
  },
  {
    path: "/menu-categories/new",
    name: "menu-categories-create",
    component: MenuCategoryEdit,
  },
  {
    path: "/subcategory-tags",
    name: "subcategory-tags",
    component: SubcategoryTagPage,
  },
  {
    path: "/subcategory-tags/new",
    name: "subcategory-tags-create",
    component: SubcategoryTagEdit,
  },
  {
    path: "/subcategory-tags/:id/edit",
    name: "subcategory-tags-edit",
    component: SubcategoryTagEdit,
  },
  {
    path: "/categories",
    name: "categories-list",
    component: Categories,
  },
  {
    path: "/categories/edit/:id?",
    name: "categories-edit",
    component: CategoryEdit,
  },
  {
    path: "/subcategories",
    name: "subcategories-list",
    component: Subcategories,
  },
  {
    path: "/subcategories/edit/:id?",
    name: "subcategories-edit",
    component: SubcategoryEdit,
  },
];

const router = VueRouter.createRouter({
  history: VueRouter.createWebHistory(),
  routes,
});

export default router;
